export default "__VITE_PUBLIC_ASSET__782bbe51__"